import { render } from "./CardRit2.vue?vue&type=template&id=0699fb9e&ts=true"
import script from "./CardRit2.vue?vue&type=script&lang=ts"
export * from "./CardRit2.vue?vue&type=script&lang=ts"

import "./CardRit2.vue?vue&type=style&index=0&id=0699fb9e&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__